"use client";

import { useEffect, useState } from "react";
import { useSession as useBetterAuthSession } from "@/lib/client/auth/client";
import { fetcher } from "@/lib/http/fetcher";
import type { UserForClient } from "@/lib/shared/types/interfaces";

export const useUser = () => {
  const { data: session, isPending: loading, error: sessionError } = useBetterAuthSession();
  const [user, setUser] = useState<UserForClient>();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchUser() {
      if (!session?.user) {
        setUser(undefined);
        setError(null);
        return;
      }

      try {
        const payloadUser = await fetcher<UserForClient>("/api/users/me");
        if (payloadUser) {
          setUser(payloadUser);
        } else {
          setError(new Error("User not found in Payload CMS"));
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to fetch user"));
      }
    }

    if (!loading && session) {
      void fetchUser();
    } else if (!(loading || session)) {
      setUser(undefined);
      setError(null);
    }
  }, [session, loading]);

  return {
    loading,
    error: error || (sessionError ? new Error(sessionError.message) : null),
    session: session ? { user: session.user } : null,
    user,
  };
};
